import { h, Fragment } from 'preact';
import clsx from 'clsx';
import Image from '../utils/image';
import VideoPlayer from '../media/VideoPlayer';

const ColumnInnerMedia = ({
  data,
  isHovered,
  isOpened,
  currentMediaItem,
  isLifestyleImageBordered,
  lifestyleImageBorderColor
}) => {
  const {
    imageBgDesktop,
    imageBgMobile,
    imageBgMobileModal,
    videoDesktop,
    videoMobile,
    lifestyleImages,
  } = data;
  const MEDIA_BG_COVER_CLASS =
    'w-full h-full object-cover object-center absolute inset-0';

  const isMediaUrlExists = (url) => url?.length > 0;
  const showLifestyleImage = (index) => index === currentMediaItem && isOpened
  const isShowVideoControls =
    typeof window !== 'undefined' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const lifestyleImagesHolder = () => (
    <column-inner-lifestyle-images
      className={clsx(
        `absolute`,
        `w-full h-full top-0 left-0`,
        `px-[60px] laptop:px-[110px]`,
      )}
    >
      <images-holder
        className={`flex relative w-full h-full`}
        style={`color: ${lifestyleImageBorderColor};`}
      >
        {lifestyleImages.map((url, i) => (
          <Image
            key={i}
            classes={clsx(
              `max-h-[500px] absolute transform`,
              `top-1/2 -translate-y-1/2`,
              `left-1/2 -translate-x-1/2`,
              `transition-all duration-500 ease-in-out`,
              isLifestyleImageBordered
                ? 'border-[7px] laptop:border-[14px] transform-gpu will-change-[transform]'
                : 'border-0',
              showLifestyleImage(i) ? 'opacity-100' : 'opacity-0',
            )}
            src={url}
          />
        ))}
      </images-holder>
    </column-inner-lifestyle-images>
  );

  const videoBg = () => (
    <VideoPlayer
      mobileVideo={videoMobile || videoDesktop}
      desktopVideo={videoDesktop}
      controls={isShowVideoControls}
      controlsPlacement={'top-2.5 laptop:top-auto laptop:bottom-5 justify-end'}
      classNames={'laptop:max-h-[1080px] object-cover object-center'}
      isPlaying={isHovered || isOpened}
    />
  );

  const mobileModalBg = imageBgMobileModal || imageBgMobile;

  const imagesBg = () => (
    <>
      {isMediaUrlExists(imageBgDesktop) ? (
        <Image
          classes={clsx(
            MEDIA_BG_COVER_CLASS,
            isMediaUrlExists(mobileModalBg) ? 'hidden laptop:block' : '',
          )}
          src={imageBgDesktop}
        />
      ) : null}
      {isMediaUrlExists(mobileModalBg) ? (
        <Image
          classes={`${MEDIA_BG_COVER_CLASS} laptop:hidden`}
          src={mobileModalBg}
        />
      ) : null}
    </>
  );

  return (
    <column-inner-media className='w-full'>
      {isMediaUrlExists(videoDesktop) ? videoBg() : imagesBg()}
      {lifestyleImages.length > 0 && lifestyleImagesHolder()}
    </column-inner-media>
  );
};

export default ColumnInnerMedia;
